function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -3)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.124 8a7.502 7.502 0 0013.752 0A7.502 7.502 0 001.124 8z",
  stroke: "#9CA6B0",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#9CA6B0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 8,
  cy: 8,
  r: 2
}));
function SvgSeenGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10
  }, props), _ref);
}
export default SvgSeenGray;